// extracted by mini-css-extract-plugin
export default {"root":"FileSuggestion_root__+0nXN","placeholder":"FileSuggestion_placeholder__LWB5+","thumbnail":"FileSuggestion_thumbnail__j2iJ8"};